import { useControlStore } from '@editorStores'
import { useIfcMode } from '@editorHooks'

interface Guided {
  isGuidedActive: boolean
  /** Enter guided mode; `uploadCompleted` pre-marks the upload step as done (skipped). */
  startGuided: (uploadCompleted: boolean) => void
  toggleGuided: () => void
  closeGuided: () => void
}

/**
 * Guided IFC import wizard state for the IFC Import page, backed by the shared `ifcMode`
 * control-store value. While active, the page drawer shows the GuidedIFCDrawer.
 */
const useIFCImportGuided = (): Guided => {
  const { ifcMode, setIfcMode } = useIfcMode()
  const setUploadCompleted = useControlStore(state => state.setIfcGuidedUploadCompleted)

  const isGuidedActive = ifcMode === 'guided'

  const startGuided = (uploadCompleted: boolean) => {
    setUploadCompleted(uploadCompleted)
    setIfcMode('guided')
  }

  const toggleGuided = () => (isGuidedActive ? setIfcMode(null) : startGuided(false))

  const closeGuided = () => {
    setIfcMode(null)
    setUploadCompleted(false)
  }

  return { isGuidedActive, startGuided, toggleGuided, closeGuided }
}

export default useIFCImportGuided
